import React from 'react'

import Page from '../../../../components/pdf/Page'
import Header from './sections/Header'
import Content from './sections/Content'
import Footer from './sections/Footer'
import Separator from '../../../../components/pdf/Separator'
import PageMargins from '../_shared/PageMargins'

const PdfDocument = () => {
  return (
    <Page footer={<Footer />} header={<Header />}>
      <PageMargins />
      <Separator weight={5} />
      <Content />
      <Separator weight={5} />
    </Page>
  )
}

export default PdfDocument
